import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(auth)/login/login-form.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")